import { gql } from "@apollo/client";

export const MUTATION_REMOVE_LINKED_CARD = gql`
  mutation RemoveLinkedCard($cardId: ID!, $externalId: ID!) {
    removeLinkedCard(cardId: $cardId, externalId: $externalId) {
      id
    }
  }
`;
